import dayjs from 'dayjs';

const statuses = {
  NOT_SUBMITTED: { label: 'Még nincs beküldve', color: 'default' },
  PENDING: { label: 'Küldésre vár', color: 'warning' },
  RETRY_PENDING: { label: 'Újraküldésre vár', color: 'warning' },
  SENDING: { label: 'Küldés folyamatban', color: 'info' },
  SENT: { label: 'Elküldve', color: 'info' },
  PROCESSING: { label: 'Feldolgozás alatt', color: 'info' },
  PROCESSED: { label: 'Feldolgozott', color: 'success' },
  DONE: { label: 'NAV feldolgozta', color: 'success' },
  MANUALLY_ACCEPTED: { label: 'Manuálisan elfogadott', color: 'success' },
  ABORTED: { label: 'NAV elutasította', color: 'error' },
  FAILED: { label: 'Sikertelen', color: 'error' },
  CANCELLED: { label: 'Megszakítva', color: 'default' },
};

export const getNavOnlineStatus = (communication) => {
  if ([communication?.state, communication?.status, communication?.communicationStatus].includes('MANUALLY_ACCEPTED')) {
    return statuses.MANUALLY_ACCEPTED;
  }
  const invoiceStatus = communication?.navInvoiceStatus;
  const status = invoiceStatus === 'DONE' || invoiceStatus === 'ABORTED'
    ? invoiceStatus
    : communication?.communicationStatus === 'RETRY_PENDING'
      ? 'RETRY_PENDING'
      : communication?.state ?? communication?.status;

  return statuses[status] ?? { label: status || 'Ismeretlen állapot', color: 'default' };
};

export const formatNavOnlineDate = (value) => {
  if (!value) return '–';
  const date = dayjs(value);
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : '–';
};

export const getNavOnlineErrorText = (status) =>
  [status?.errorCode, status?.errorMessage].filter(Boolean).join(': ');

export const getNavOnlineOperation = (operation) => ({
  TOKEN_EXCHANGE: 'Tokenkérés',
  MANAGE_INVOICE: 'Számla beküldése',
  QUERY_TRANSACTION_STATUS: 'Feldolgozási státusz lekérdezése',
  QUERY_TAXPAYER: 'Belföldi adószám ellenőrzése',
  QUERY_VAT_NUMBER: 'Külföldi adószám ellenőrzése',
  QUERY_INVOICE_DATA: 'Számlaadatok lekérdezése',
  MANAGE_ANNULMENT: 'Technikai érvénytelenítés',
}[operation] ?? operation);

export const getNavOnlineInvoiceOperation = (operation) => ({
  CREATE: 'Eredeti számla',
  MODIFY: 'Módosító számla',
  STORNO: 'Stornószámla',
}[operation] ?? operation);

export const getNavOnlineValidationSeverity = (resultCode) => {
  if (resultCode === 'WARN' || resultCode === 'WARNING') return 'warning';
  if (resultCode === 'INFO') return 'info';
  return 'error';
};
